import React, { useState } from "react";
import { format } from "date-fns";

const EmailHistory = ({ emailHistory }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!emailHistory) return null;

  const { oldEmail, changedAt, changedBy } = emailHistory;

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), "dd MMM yyyy 'at' HH:mm");
    } catch (error) {
      return dateString;
    }
  };

  const formatDateShort = (dateString) => {
    try {
      return format(new Date(dateString), "dd MMM yyyy");
    } catch (error) {
      return dateString;
    }
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  // Collapsed state
  if (!isExpanded) {
    return (
      <div
        onClick={toggleExpand}
        style={{
          background: "linear-gradient(135deg, #e8eaf6 0%, #f3e5f5 100%)",
          borderRadius: "8px",
          padding: "12px 16px",
          marginTop: "12px",
          marginBottom: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          border: "1px solid #d1d9e6",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #dce1f0 0%, #e8d9ed 100%)";
          e.currentTarget.style.boxShadow = "0 3px 6px rgba(0, 0, 0, 0.12)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #e8eaf6 0%, #f3e5f5 100%)";
          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: "16px", height: "16px", marginRight: "8px" }}
              viewBox="0 0 512 512"
              fill="#667eea"
            >
              <path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
            </svg>
            <span
              style={{
                color: "#424242",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              Email changed on {formatDateShort(changedAt)}
            </span>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "16px", height: "16px" }}
            viewBox="0 0 512 512"
            fill="#667eea"
          >
            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
          </svg>
        </div>
      </div>
    );
  }

  // Expanded state
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        borderRadius: "12px",
        padding: "16px",
        marginTop: "12px",
        marginBottom: "12px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(255, 255, 255, 0.18)",
      }}
    >
      <div
        className="d-flex align-items-center justify-content-between mb-2"
        onClick={toggleExpand}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "20px", height: "20px", marginRight: "8px" }}
            viewBox="0 0 512 512"
            fill="#ffffff"
          >
            <path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
          </svg>
          <h6
            className="font-weight-bold"
            style={{
              color: "#ffffff",
              margin: 0,
              fontSize: "14px",
              letterSpacing: "0.5px",
            }}
          >
            EMAIL CHANGE HISTORY
          </h6>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "16px", height: "16px" }}
          viewBox="0 0 512 512"
          fill="#ffffff"
        >
          <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
        </svg>
      </div>

      <div style={{ paddingLeft: "28px" }}>
        <div className="d-flex align-items-start mb-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              width: "16px",
              height: "16px",
              marginRight: "8px",
              marginTop: "2px",
              flexShrink: 0,
            }}
            viewBox="0 0 512 512"
            fill="#ffd700"
          >
            <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
          </svg>
          <div>
            <span
              style={{
                color: "rgba(255, 255, 255, 0.7)",
                fontSize: "12px",
                display: "block",
              }}
            >
              Previous Email
            </span>
            <span
              style={{
                color: "#ffffff",
                fontSize: "14px",
                fontWeight: "600",
                wordBreak: "break-all",
              }}
            >
              {oldEmail}
            </span>
          </div>
        </div>

        <div className="d-flex align-items-start mb-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              width: "16px",
              height: "16px",
              marginRight: "8px",
              marginTop: "2px",
              flexShrink: 0,
            }}
            viewBox="0 0 512 512"
            fill="#90EE90"
          >
            <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
          </svg>
          <div>
            <span
              style={{
                color: "rgba(255, 255, 255, 0.7)",
                fontSize: "12px",
                display: "block",
              }}
            >
              Changed On
            </span>
            <span
              style={{
                color: "#ffffff",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {formatDate(changedAt)}
            </span>
          </div>
        </div>

        <div className="d-flex align-items-start">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              width: "16px",
              height: "16px",
              marginRight: "8px",
              marginTop: "2px",
              flexShrink: 0,
            }}
            viewBox="0 0 448 512"
            fill="#87CEEB"
          >
            <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
          </svg>
          <div>
            <span
              style={{
                color: "rgba(255, 255, 255, 0.7)",
                fontSize: "12px",
                display: "block",
              }}
            >
              Changed By
            </span>
            <span
              style={{
                color: "#ffffff",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "capitalize",
              }}
            >
              {changedBy}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailHistory;